import React, { ReactNode } from 'react';
import { ChatProvider } from '../../contexts/ChatContext';
import { ModelProvider } from '../../contexts/ModelContext';
import { KnowledgeBaseProvider } from '../../contexts/KnowledgeBaseContext';
import { LiteratureProvider } from '../../contexts/LiteratureContext';

/**
 * AuthenticatedProviders
 *
 * Wraps providers that are only needed for authenticated users.
 * This component should be placed inside ProtectedRoute to ensure
 * these providers only mount when user is authenticated.
 *
 * Benefits:
 * - Providers only mount when needed (better performance)
 * - No need to check auth status inside each provider
 * - Clear separation of concerns
 */
interface AuthenticatedProvidersProps {
  children: ReactNode;
}

export const AuthenticatedProviders: React.FC<AuthenticatedProvidersProps> = ({ children }) => {
  return (
    <ModelProvider>
      <ChatProvider>
        <KnowledgeBaseProvider>
          <LiteratureProvider>{children}</LiteratureProvider>
        </KnowledgeBaseProvider>
      </ChatProvider>
    </ModelProvider>
  );
};
